import { useQuery } from "@tanstack/react-query";
import { api, errorOf } from "./api";

/**
 * A record's audit trail, newest first: the latest 50 entries for one target (GET
 * /v1/admin/audit, staff.manage). The full log, with its filters, is Settings › Audit log (P8-22).
 */
export function useActivity(targetType: string, targetId: string | null, enabled = true) {
  return useQuery({
    queryKey: ["activity", targetType, targetId],
    enabled: enabled && targetId !== null,
    queryFn: async () => {
      const { data, error } = await api.GET("/v1/admin/audit", {
        params: { query: { target_type: targetType, target_id: targetId ?? undefined, limit: 50 } },
      });
      if (error || !data) throw errorOf(error);
      return data.data;
    },
  });
}
